<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <img :src="baseImgSrc" class="baseImage">
  </div>
</template>
<script>
// import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate, UrlBase64 } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { getToken } from '@/utils/auth'
import { GetServiceUrl } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '电子证书',
      backurl: '/my/index',
      userCertificateVirtualId: undefined,
      baseImgSrc: ''
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.userCertificateVirtualId = this.$route.params.id
    this.baseImgSrc = undefined
    this.baseImgSrc = GetServiceUrl() + 'image/getBaseCard?userCertificateVirtualId=' + this.userCertificateVirtualId +
        '&token=' + UrlBase64(getToken())
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate
  }
}
</script>
<style scoped>
.baseImage{
    width: 100%;
}
</style>
